import React, { useId, useRef } from 'react';
import { Button, IconButton, Box, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const FileInput = ({ onFileSelect, onFileRemove, onFileUpload, file, setFile, accept = 'image/*' }) => {
  const ref = useRef();
  const inputId = useId();

  return (
    <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" gap={2}>
      <input
        type="file"
        accept={accept}
        ref={ref}
        onChange={onFileSelect}
        style={{ display: 'none' }}
        // id="mui-file-input"
        id={inputId}
      />
      {/* <label htmlFor="mui-file-input"> */}
      <label htmlFor={inputId}>
        <Button variant="contained" component="span">
          Choose File
        </Button>
      </label>

      {file && (
        <Box display="flex" alignItems="center" gap={2}>
          <Typography variant="body2">{file.name}</Typography>
          <IconButton
            color="error"
            onClick={() => {
              onFileRemove();
              ref.current.value = '';
            }}
          >
            <DeleteIcon />
          </IconButton>
          {onFileUpload && (
            <Button
              variant="outlined"
              onClick={() => {
                onFileUpload();
              }}
            >
              Upload
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default FileInput;